import React from 'react';
import { Card, Row, Col, Tooltip } from 'antd';
import {
  CheckCircleOutlined,
  ExclamationCircleOutlined,
  CloseCircleOutlined,
  SyncOutlined
} from '@ant-design/icons';

const InfoTile = ({ title, handleClick, statusList }) => {
  const getIcon = status => {
    switch (status) {
      case 'Gut':
      case 'Online':
      case 'Verknüpft':
        return (
          <CheckCircleOutlined
            style={{ fontSize: '24px', color: '#4CAF50', margin: '0 8px' }}
          />
        );

      case 'Niedrig':
      case 'Unverknüpft':
        return (
          <ExclamationCircleOutlined
            style={{ fontSize: '24px', color: '#FF9800', margin: '0 8px' }}
          />
        );

      case 'Schlecht':
      case 'Offline':
        return (
          <CloseCircleOutlined
            style={{ fontSize: '24px', color: '#F44336', margin: '0 8px' }}
          />
        );

      case 'Unbekannt':
        return (
          <ExclamationCircleOutlined
            style={{ fontSize: '24px', color: '#9E9E9E', margin: '0 8px' }}
          />
        );

      case 'Synchronisiert':
        return (
          <SyncOutlined
            style={{ fontSize: '24px', color: '#4CAF50', margin: '0 8px' }}
          />
        );

      case 'Nicht synchronisiert':
        return (
          <ExclamationCircleOutlined
            style={{ fontSize: '24px', color: '#F44336', margin: '0 8px' }}
          />
        );

      default:
        return null;
    }
  };

  return (
    <Card
      title={title}
      bordered={false}
      onClick={handleClick}
      style={{
        cursor: 'pointer',
        minHeight: "35vh",
        flex: 1,
        margin: '0 8px',
        boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column',
        height: "100%",
        alignSelf: 'stretch',
      }}
    >
      <Row gutter={8} style={{ textAlign: 'center', alignItems: 'center', flexFlow: 'nowrap' }}>
        {statusList.map((status, index) => {
          const [statusName, count] = status.split(': ');
          return (
            <Col key={index}>
              <Tooltip title={status}>{getIcon(statusName)}</Tooltip>
              <div style={{ fontSize: '18px' }}>{count}</div>
            </Col>
          );
        })}
      </Row>
    </Card>
  );
};

export default InfoTile;
